import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from 'store/redux';
import {toggleSideBar} from 'store/redux/sideBar';
interface SidebarCategoriesHeaderProps {
  title: string;
}
const SidebarCategoriesHeader = ({title}: SidebarCategoriesHeaderProps) => {
  const dispatch = useDispatch();
  const {isOpen} = useSelector((state: RootState) => state.sideBarControler);
  return (
    <>
      <div
        className="flex mb-4 items-center  mt-6"
        onClick={() => dispatch(toggleSideBar({isOpen: !isOpen}))}
      >
        <button className='mt-[8px]'>
          <span className="icon-menu text-primary ml-2" />
        </button>
        <div className=" text-gray-6">دسته‌بندی محصولات</div>
      </div>
    </>
  );
};

export default SidebarCategoriesHeader;
